import React, { useState } from "react";
import { TextField, IconButton, InputAdornment } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

export default function Input(props) {
  const { name, label, value, error = null, onChange, type, ...other } = props;
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  // Render for file input
  if (type === "file") {
    return (
      <input
        accept="image/*"
        type="file"
        name={name}
        onChange={onChange}
        {...other}
      />
    );
  }

  // Render for other input types
  return (
    <TextField
      variant="outlined"
      label={label}
      name={name}
      value={value}
      type={type === "password" && !showPassword ? "password" : "text"}
      onChange={onChange}
      autoFocus
      {...other}
      {...(error && { error: true, helperText: error })}
      InputProps={{
        endAdornment: type === "password" ? (
          <InputAdornment position="end">
            <IconButton
              onClick={handleClickShowPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );
}